import React, { useEffect } from 'react';
import { BankItemProps } from '../index';
import { useStateReducer } from '../../../../hooks';
import Heading from '../../../../_global/components/heading/Heading';
import { Form } from '../../../../components';
import { InstructionWrapper, TextField } from '../../../../components/fields';

export default function ViewItem({
  data: { code, _id, mx_code, name, rank }
}: BankItemProps) {
  const [state, setState] = useStateReducer({});

  useEffect(() => {}, []);

  return (
    <div id='banks-view-item' className='read-only'>
      <Heading name={name} />
      <Form title='Bank Details'>
        <InstructionWrapper text='Bank name and rank' row>
          <TextField label='Bank Name' value={name} readOnly />
          <TextField label='Rank' value={rank} readOnly />
        </InstructionWrapper>
        <InstructionWrapper text='Bank code and mx_code' row>
          <TextField label='Code' value={code} readOnly />
          <TextField label='Mx Code' value={mx_code} readOnly />
        </InstructionWrapper>
      </Form>
    </div>
  );
}
